import type { RenamePlan } from '@cli-types/core-engine/snapshots.js'
import type { Node } from 'ts-morph'
import { getJsxAttributeName } from './get-jsx-attribute-name.js'
import { replacePathSegments } from './replace-path-segments.js'

export function replaceTemplateLiteralValue(value: string, node: Node, plan: RenamePlan): string {
  const jsxAttribute = getJsxAttributeName(node)
  if (jsxAttribute !== 'name' && jsxAttribute !== 'id' && jsxAttribute !== 'htmlFor') {
    return value
  }

  return plan.fields.reduce(
    (next, rename) => replacePathSegments(next, rename.before, rename.after),
    value
  )
}
